import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Button, Spinner } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { postData } from '../ApiServices/ApiService';
// import { BsMic } from 'react-icons/bs';
import { FaStop, FaMicrophone } from "react-icons/fa";
//import axios from 'axios';

const UsersInterview = () => {
  const [searchParams] = useSearchParams();
  const testId = searchParams.get('id');
  const navigate = useNavigate();
  const [isRecording, setIsRecording] = useState(false);
  const [audioChunks, setAudioChunks] = useState([]);
  const [loading, setLoading] = useState(false);

  const audioStreamRef = useRef(null);
  const mediaRecorderRef = useRef(null);

  const [questions, setQuestions] = useState([]);
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [timer, setTimer] = useState(60); // 3 minutes in seconds
  const [showSubmitButton, setShowSubmitButton] = useState(false);
  const [isTimerRunning, setIsTimerRunning] = useState(true);
  const [error, setError] = useState('Loading ...');
  const [respError, setRespError] = useState('');
  // var getQuestionsIntervel;
  
  const [questionChunksList, setQuestionChunksList] = useState([]);
  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const payload = {"test_id": testId,}
        postData('candidate_test_questions_get', payload).then(resp => {
          resp.json().then(respData => {
            if (resp.status === 200) {
              if (respData.statusCode === 200) {
                if (respData.message.toLowerCase() === 'success') {
                  if (respData.dataJ.questions.length > 0) {
                    setError('')
                    setQuestions(respData.dataJ.questions);
                    setTotalQuestions(respData.dataJ.questions.length);
                    // clearInterval(getQuestionsIntervel);
                    console.log('resp else lenth : ', respData.dataJ.questions.length, totalQuestions);
                  } else {
                    if (respData.info.toLowerCase() === 'questions are being generated') {
                      setTimeout(() => {
                        fetchQuestions();
                      }, 5000);
                    }
                    setError(respData.info);
                  }
                } else {
                  setError(respData.info);
                  console.log('resp else s : ', resp.info);
                }
              } else if(respData.statusCode === 500) {
                setError(respData.info);
                console.log('resp else  : ', resp.info);
              }else{
                setError('Network Error');
              }
            } else if (resp.status === 401 || resp.status === 403) {
              console.log('resp status else if : ', resp.status);
              if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
                || respData.message === 'Access Denied') {
                //   callRefreshTokenApi('getSfeBatch', '');
              }
            }else {
              console.log('resp status else  : ', resp);
            }
          }).catch((error) => {
            setError('Network Error');
            console.log('network error:', error);
          });
        }).catch((error) => {
          setError('Network Error');
          console.log('network error:', error);
        });


      } catch (error) {
        console.error('Error fetching questions:', error);
      }
    };

    fetchQuestions();
  }, []);

  useEffect(() => {
    let timerId;
    if (isTimerRunning && timer > 0) {
      timerId = setTimeout(() => setTimer(timer - 1), 1000);
    } else if (timer === 0) {
      let totalQuestion = totalQuestions - 2;
      if (currentQuestionIndex > totalQuestion) {
        //End of total test
        //handleRecordingStop();
        handleSubmit();
      } else {
    // nextType ==> LAST,NORMAL,BUTTON
    //stopMicTypes: MIC,SUBMIT,AUTOSUBMIT
        handleNextQuestion("NORMAL","AUTOSUBMIT"); //Automatic Submit and Normal
      }
    } else {
      console.log('not 0');
    }

    return () => clearTimeout(timerId);
  }, [timer, isTimerRunning]);



  const handleRecordingStart = async () => {
    console.log("handleRecordingStart()............................");
    setAudioChunks([]);
    try {
      audioStreamRef.current = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(audioStreamRef.current);

      mediaRecorderRef.current.ondataavailable = (e) => {
        if (e.data.size > 0) {
          setAudioChunks((prevChunks) => [...prevChunks, e.data]);
        }
      };

      mediaRecorderRef.current.onstop = () => {
        console.log("handleRecordingStart onstop()");
        setAudioChunks((prevChunks) => {
          console.log("handleRecordingStart onstop() setAudioChunks()");
          const audioBlob = new Blob(prevChunks, { type: 'audio/wav' });
          const reader = new FileReader();
          reader.onload = () => {
            console.log("handleRecordingStart onstop() onload()");
            const base64String = reader.result.split(',')[1];
            convertBlobToText(currentQuestion?.qid, base64String);
          };
          reader.readAsDataURL(audioBlob);
          setQuestionChunksList((prevList) => [...prevList, ...prevChunks]);

          return prevChunks; // Return the new state
        });

      };

      mediaRecorderRef.current.start();
      setIsRecording(true);
    } catch (error) {
      console.error('Error accessing microphone:', error);
    }
  };


  //stopMicTypes: MIC,SUBMIT,AUTOSUBMIT
  const handleRecordingStop = (stopMicTypes) => {
    console.log("handleRecordingStop()............................",stopMicTypes);
    if (mediaRecorderRef.current) {
      //console.log('mic stop')
      mediaRecorderRef.current.stop();
      audioStreamRef.current.getTracks().forEach((track) => track.stop());
      setIsRecording(false);
      //console.log('onstop audioChunks:new ', audioChunks);
    } else {
      console.error('mediaRecorderRef.current', mediaRecorderRef.current);
    }
  };

  const handleMicClick = () => {
    if (isRecording) {
      handleRecordingStop("MIC");
    } else {
      handleRecordingStart();
    }
  };

  const handleNextQuestion = async (nextType,stopMicType) => {
    // nextType ==> LAST,NORMAL,BUTTON
    //stopMicTypes: MIC,SUBMIT,AUTOSUBMIT
    handleRecordingStop("SUBMIT");
    
    console.log('handleNextQuestion  nextType:', nextType," stopMicType:",stopMicType);
    var li = questionChunksList;
    console.log("li:",li);
    var filteredList = [];
    for (let i = 0; i < li.length; i++) {
      const item = li[i];
      if (i % 2 === 0) {
        filteredList.push(item);
      }
      
    }
    console.log("filteredList:",filteredList);
    const audioBlob = new Blob(filteredList, { type: 'audio/wav' });
    const reader = new FileReader();
    reader.onload = () => {
      console.log("handleNextQuestion()");
      const base64String = reader.result.split(',')[1];
      convertBlobToTextFinal(currentQuestion?.qid, base64String);
    };
    reader.readAsDataURL(audioBlob);
    setQuestionChunksList([]);
    setAudioChunks([]);
    console.log('setAudioChunks []', audioChunks);

    // nextType ==> LAST,NORMAL,BUTTON
    if(nextType !== "LAST"){
      setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
      setShowSubmitButton(false);
      setTimer(60);
      let totalQuestion = totalQuestions - 3;
      if (currentQuestionIndex > totalQuestion) {
        setShowSubmitButton(true);
      }
    }


  };


  const convertBlobToText = async (qId, blobAudio) => {
    console.log('Service convertBlobToText qId', qId, 'blobAudio',);    
    const payload = {
      "op":"audio_trans",
      "test_id": testId,
      "qid": qId,
      "audio_data": blobAudio
    }
    postData('candidate_audio_transcription', payload).then(resp => {
      resp.json().then(respData => {
        if (resp.status === 200) {
          if (respData.statusCode === 200) {
            const questionIndex = questions.findIndex((question) => question.qid === respData.dataJ.qId);

            // If the question is found, update its answer to an empty string
            if (questionIndex !== -1) {
              const updatedQuestions = [...questions];
              updatedQuestions[questionIndex] = {
                ...updatedQuestions[questionIndex],
                q_answer: updatedQuestions[questionIndex].q_answer + respData.dataJ.q_answer,// (for concatenate existing and New)
              };
              setQuestions(updatedQuestions);
            }
 
          } else if(respData.statusCode === 500) {
            setError(respData.info);
            console.log('resp else  : ', resp.info);
          }else{
            setError('Network Error');
          }
        } else if (resp.status === 401 || resp.status === 403) {
          console.log('resp status else if : ', resp.status);
          if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
            || respData.message === 'Access Denied') {
            //   callRefreshTokenApi('getSfeBatch', '');
          }
        }else {
          console.log('resp status else  : ', resp);
        }
      }).catch((error) => {
        setError('Network Error');
        console.log('network error:', error);
      });
    }).catch((error) => {
      setError('Network Error');
      console.log('network error:', error);
    });
  }

  const convertBlobToTextFinal = async (qId, blobAudio) => {
    console.log('Service convertBlobToTextFinal qId', qId, 'blobAudio',);    
    const payload = {
      "op":"audio_trans_final",
      "test_id": testId,
      "qid": qId,
      "audio_data": blobAudio
    }
    postData('candidate_audio_transcription', payload).then(resp => {
      resp.json().then(respData => {
        if (resp.status === 200) {
          if (respData.statusCode === 200) {
            const questionIndex = questions.findIndex((question) => question.qid === respData.dataJ.qId);

            // If the question is found, update its answer to an empty string
            if (questionIndex !== -1) {
              const updatedQuestions = [...questions];
              updatedQuestions[questionIndex] = {
                ...updatedQuestions[questionIndex],
                q_answer: respData.dataJ.q_answer,// (for New)
              };
              setQuestions(updatedQuestions);
            }
 
          } else if(respData.statusCode === 500){
            setError(respData.info);
            console.log('resp else  : ', resp.info);
          }else{
            setError('Network Error');
          }
        } else if (resp.status === 401 || resp.status === 403) {
          console.log('resp status else if : ', resp.status);
          if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
            || respData.message === 'Access Denied') {
            //   callRefreshTokenApi('getSfeBatch', '');
          }
        }else {
          console.log('resp status else  : ', resp);
        }
      }).catch((error) => {
        setError('Network Error');
        console.log('network error:', error);
      });
    }).catch((error) => {
      setError('Network Error');
      console.log('network error:', error);
    });
  }


  //Last Question Submit
  const handleSubmit = async () => {
    //stopMicTypes: MIC,SUBMIT,AUTOSUBMIT
    handleRecordingStop("SUBMIT");
    handleNextQuestion("LAST","AUTOSUBMIT");//LAST,NORMAL,BUTTON
    setLoading(true);
    setTimeout(async () => {
      const formattedAnswers = questions.map((question, index) => ({
        qid: question.qid,
        q_text: question.q_text,
        q_answer: question?.q_answer || 'I dont know the answer', // Use the user's answer if available, otherwise an empty string
      }));
      try {
        const payload = {
          test_id: testId,
          questions_answers: formattedAnswers
        };
        console.log('payload', payload);
        // return

        await postData('candidate_submit_answers', payload).then(resp => {
          setLoading(false);
          resp.json().then(respData => {
            if (resp.status === 200) {
              if (respData.statusCode === 200) {
                if (respData.message.toLowerCase() === 'success') {
                  navigate(`/users-summary?id=${payload.test_id}`);
                  setCurrentQuestionIndex(0);
                  setShowSubmitButton(false);
                  setIsTimerRunning(false);

                } else {
                  setRespError(resp.info);
                  console.log('resp else s : ', resp.info);
                }
              } else if(respData.statusCode === 500) {
                setRespError(resp.info);
                console.log('resp else  : ', resp.info);
              }else{
                setRespError('Network Error')
              }
            } else if (resp.status === 401 || resp.status === 403) {
              console.log('resp status else if : ', resp.status);
              if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
                || respData.message === 'Access Denied') {
                //   callRefreshTokenApi('getSfeBatch', '');
                setRespError(resp.message);
              }
            }else {
              setRespError(resp.info);
              console.log('resp status else  : ', resp);
            }
          }).catch((error) => {
            setRespError(error);
            console.log('network error:', error);
          });
        }).catch((error) => {
          setLoading(false);
          setRespError(error);
          console.log('network error:', error);
        });
        // Send all responses to your API


      } catch (error) {
        console.error('Error submitting answers:', error);
        // Optionally, you can reset the state or navigate to a new page after submitting
        setCurrentQuestionIndex(0);
        setShowSubmitButton(false);
        setIsTimerRunning(false);
      }
    }, 2000);

  };

  const handleClearAns = (qId) => {
    // Find the index of the question with the specified qid
    const questionIndex = questions.findIndex((question) => question.qid === qId);

    // If the question is found, update its answer to an empty string
    if (questionIndex !== -1) {
      const updatedQuestions = [...questions];
      updatedQuestions[questionIndex] = {
        ...updatedQuestions[questionIndex],
        q_answer: '',
      };
      setQuestions(updatedQuestions);
    }
    
    setQuestionChunksList([]);

    
  }

  const currentQuestion = questions[currentQuestionIndex];

  return (
    <div className='user-qus-div'>
      <div className="question-div">
        <Row className="justify-content-center">
          <Col xs={12} md={12}>
            {questions.length !== 0 ? (
              <div>
                <h2 className="text-center mb-4">Question {currentQuestion?.qid}</h2>
                <p className="text-center">{currentQuestion?.q_text}</p>

                <div className='d-flex'>
                  <div className="text-center mt-3 flex-grow-1">
                    <textarea
                      readOnly
                      className="form-control"
                      value={currentQuestion?.q_answer}
                      placeholder="Your answer..."
                    />
                  </div>

                  <div className="text-center align-self-center m-left">
                    <Button variant="outline-danger" onClick={handleMicClick}>
                      {isRecording ? <FaStop className="icon" /> : <FaMicrophone className='icon' />}
                    </Button>
                  </div>

                  <div className="text-center align-self-center m-left">
                    <Button variant="outline-primary" onClick={() => handleClearAns(currentQuestion?.qid)}>
                      clear
                    </Button>
                  </div>

                </div>
                <div className="text-center mt-3">
                  <p>Time Remaining: {timer} seconds</p>
                </div>
                <div className="text-center mt-3">
                  {showSubmitButton ? (
                    <Button variant="primary" onClick={handleSubmit}>
                      Submit All Answers
                    </Button>
                  ) : (
                    <Button variant="success" onClick={()=>handleNextQuestion('BUTTON','SUBMIT')}>
                      Next Question
                    </Button>
                  )}
                </div>
                {loading && (
                  <div className="spinner-overlay">
                    <Spinner animation="border" role="status">
                      <span className="sr-only"></span>
                    </Spinner>
                  </div>
                )}
                <div>
                  {respError && <p className='error-msg'>{respError}</p>}
                </div>
              </div>
            ) : (
              <div>
                {error && <p className='error-msg'>{error}</p>}
              </div>
            )

            }

          </Col>
        </Row>
      </div>
    </div>

  );
};

export default UsersInterview;
